import React, { FC } from 'react';
import { Text as NativeText } from '@tarojs/components';
import classNames from 'classnames';
import { TextProps } from '@tarojs/components/types/Text';

const Text: FC<TextProps> = ({ className, ...restProps }) => <NativeText className={classNames('ink-text', className)} {...restProps} />;

export default Text;
